import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';

@Component({
  selector: 'app-older-month-selector',
  templateUrl: './older-month-selector.component.html',
  styleUrls: ['./older-month-selector.component.scss']
})
export class OlderMonthSelectorComponent implements OnInit {
  @Input() data: Array<string> = [];
  @Output() change = new EventEmitter();
  years = [];
  constructor(
      public bsModal: BsModalRef
  ) { }

  ngOnInit() {
    let yearsLU = {};
   this.data.forEach(i => {
     let y = i.split('-');
     if (typeof yearsLU[y[1]] !== 'undefined'){
       yearsLU[y[1]].push(i);
     }else{
       yearsLU[y[1]] = [i];
     }
   });
   Object.keys(yearsLU).map( key => {
     this.years.push({year: key, months: yearsLU[key]})
   });
   this.years = this.years.sort( (a,b) => a.year > b.year ? -1 : 1);
  }
  hide(){
    this.bsModal.hide();
  }

  emit(month){
    this.change.emit(month);
    this.hide();
  }

}
